const BOOM_AUDIO = /boomaudio/i

export function preferBoomAudio(
  devices: MediaDeviceInfo[]
): MediaDeviceInfo[] {
  const isBoom = (device: MediaDeviceInfo) => BOOM_AUDIO.test(device.label)
  const boom = devices.filter(isBoom)
  if (boom.length === 0) return devices
  return [...boom, ...devices.filter((device) => !isBoom(device))]
}
